import { render, staticRenderFns } from "./add-jewel-modal-link.vue?vue&type=template&id=0f5693ac"
import script from "./add-jewel-modal-link.vue?vue&type=script&lang=js"
export * from "./add-jewel-modal-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports